import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll window to top whenever the route path changes (fixes landing mid-page). */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
